import React, { useState } from "react";
import Modalform from "../Formularz/Modalform";

import { images } from "../../constants";
import "./OMnie.css";

const Omnie = () => {
    const [openModal, setOpenModal] = useState(false);

    document.addEventListener("DOMContentLoaded", function (event) {
        document.addEventListener("scroll", function (event) {
            const animatedBoxes =
                document.getElementsByClassName("animated-box");
            const windowOffsetTop = window.innerHeight + window.scrollY;

            Array.prototype.forEach.call(animatedBoxes, (animatedBox) => {
                const animatedBoxOffsetTop = animatedBox.offsetTop;

                if (windowOffsetTop >= animatedBoxOffsetTop) {
                    addClass(animatedBox, "fade-in");
                }
            });
        });
    });

    function addClass(element, className) {
        const arrayClasses = element.className.split(" ");
        if (arrayClasses.indexOf(className) === -1) {
            element.className += " " + className;
        }
    }

    return (
        <div className="app__headerr app__bg section__padding" id="omnie">
            <div className="x">
                <div id="containerr">
                    <img src={images.bb} alt="header_img" />
                </div>
                <h1 className="omnie-h1">Cześć!</h1>
                <p className="omnie-p animated-box">
                    Mam na imię Przemek <br />
                    Jestem trenerem personalnym, dyplomowanym dietetykiem oraz
                    trenerem przygotowania fizycznego. W branży działam od ponad
                    5 lat i ciągle rozwijam swój warsztat trenerski, poprzez
                    udział w wielu szkoleniach i kursach. Jeśli jesteś na tej
                    stronie, to znaczy, że chcesz zadbać o swoje zdrowie,
                    sylwetkę i poprawić jakość swojego życia :) <br/>Przedstawiam Ci
                    kilka propozycji współpracy, które zmotywują Cię do
                    działania oraz zmiany na lepsze!
                </p>
            </div>

            <div className="btn_omniee animated-box">
                <button
                    onClick={() => setOpenModal(true)}
                    type="button"
                    className="customm__b"
                >
                    NIE ZWLEKAJ ZACZNIJ JUŻ TERAZ !
                </button>
            </div>
            <Modalform open={openModal} onClose={() => setOpenModal(false)} />
        </div>
    );
};

export default Omnie;
